import {
  computed,
  Injectable,
  Injector,
  signal,
  WritableSignal,
} from '@angular/core';
import {
  IAMLookup,
  IAMLookupsResponse,
  LookupApi,
  UserDetailsSummary,
} from '@via/models';

import { LookupService } from './lookup.service';
import { TenantService } from './tenant.service';

@Injectable({
  providedIn: 'root',
})
export class IAMLookupService extends LookupService<
  IAMLookupsResponse,
  IAMLookup
> {
  public tenantTypes = computed(() => {
    if (!this.lookups().tenantTypes.length) {
      // this.fetchLookupsByName('tenantTypes');
    }
    return this.lookups().tenantTypes;
  });

  public tenantStatuses = computed(() => {
    if (!this.lookups().tenantStatuses.length) {
      // this.fetchLookupsByName('tenantStatuses');
    }
    return this.lookups().tenantStatuses;
  });

  public vendorTypes = computed(() => {
    if (!this.lookups().vendorTypes.length) {
      // this.fetchLookupsByName('vendorTypes');
    }
    return this.lookups().vendorTypes;
  });

  public roles = computed(() => {
    if (!this.lookups().roles.length) {
      // this.fetchLookupsByName('roles');
    }
    return this.lookups().roles;
  });

  public roleStatuses = computed(() => {
    if (!this.lookups().roleStatuses.length) {
      // this.fetchLookupsByName('roleStatuses');
    }
    return this.lookups().roleStatuses;
  });

  public permissionModules = computed(() => {
    if (!this.lookups().userModules.length) {
      // this.fetchLookupsByName('userModules');
    }
    return this.lookups().userModules.sort((a, b) => a.id - b.id);
  });

  public sites = computed(() => {
    if (!this.lookups().sites.length) {
      // this.fetchLookupsByName('sites');
    }
    return this.lookups().sites;
  });

  public teams = computed(() => {
    if (!this.lookups().teams.length) {
      // this.fetchLookupsByName('teams');
    }
    return this.lookups().teams;
  });

  public languages = computed(() => {
    if (!this.lookups().languages.length) {
      // this.fetchLookupsByName('languages');
    }
    return this.lookups().languages;
  });

  public licenseCertificationTypes = computed(() => {
    if (!this.lookups().licenseCertificationTypes.length) {
      // this.fetchLookupsByName('licenseCertificationTypes');
    }
    return this.lookups().licenseCertificationTypes;
  });

  public userTimezones = computed(() => {
    if (!this.lookups().userTimeZones.length) {
      // this.fetchLookupsByName('userTimeZones');
    }
    return this.lookups().userTimeZones;
  });

  //TODO: Remove hardcoded clients
  public clients = computed(() => {
    if (!this.lookups().clients.length) {
      //this.fetchLookupsByName('clients');
    }
    // return this.lookups().clients;
    return [
      {id: 1, name: "Wells Fargo"}, 
      {id: 2, name: "Goldman Sachs Bank"}, 
      {id: 3, name: "JPMorgan Chase"},
      {id: 4, name: "Capital One"},
    ];
  });

  public users: WritableSignal<UserDetailsSummary[]> = signal([]);

  constructor(
    private inj: Injector,
    private tenantService: TenantService
  ) {
    super(inj);

    this.lookupApi = LookupApi.IAM;
    this.lookups = signal({
      tenantTypes: [],
      tenantStatuses: [],
      vendorTypes: [],
      roles: [],
      roleStatuses: [],
      userModules: [],
      sites: [],
      teams: [],
      languages: [],
      licenseCertificationTypes: [],
      userTimeZones: [],
      clients: [],
    });
  }

  async fetchUsers() {
    const payload = {
      isActive: true,
      currentTenantId: this.tenantService.currentTenant()?.tenantId,
    };
    const userResp = await this.apiService.post<UserDetailsSummary[]>(
      'viaiam/api/users',
      payload
    );
    this.users.set(userResp);
  }

  findLookup<T = IAMLookup>(
    lookupName: keyof IAMLookupsResponse,
    val: string | number
  ) {
    return this.lookups()[lookupName as keyof IAMLookupsResponse].find(
      (l) => l.id === val || l.name === val
    ) as T | undefined;
  }
}
